import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import GroupsIcon from '@mui/icons-material/Groups';
import { FACEBOOK_COMMUNITY_URL } from '../../../config/constants';
import {
	COLOR_DRAWER_ICON_COMMUNITY,
	COLOR_DRAWER_ITEM_HOVER,
	COLOR_DRAWER_ITEM_TEXT,
} from '../../../styles/tokens';

export const CommunityLink = ({ callBack }) => {
	const handleClick = () => {
		callBack();
		window.open(FACEBOOK_COMMUNITY_URL, '_blank', 'noopener,noreferrer');
	};

	return (
		<ListItem key={'Community'} disablePadding>
			<ListItemButton
				onClick={handleClick}
				sx={{ '&:hover': { backgroundColor: COLOR_DRAWER_ITEM_HOVER } }}
			>
				<ListItemIcon
					sx={{
						color: COLOR_DRAWER_ICON_COMMUNITY,
						minWidth: '40px',
					}}
				>
					<GroupsIcon />
				</ListItemIcon>
				<ListItemText
					primary={'Community'}
					primaryTypographyProps={{
						variant: 'h5',
						sx: { color: COLOR_DRAWER_ITEM_TEXT },
					}}
				/>
			</ListItemButton>
		</ListItem>
	);
};
